<template>
  <j-modal
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭"
    switchFullscreen
  >
    <yw-duty-record-form :disabled="disableSubmit" @ok="submitCallback" ref="realForm"></yw-duty-record-form>
  </j-modal>
</template>

<script>

  import YwDutyRecordForm from './YwDutyRecordForm'
  export default {
    name: 'YwDutyRecordModal',
    components: {
      YwDutyRecordForm
    },
    data () {
      return {
        title: '',
        width: 1100,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add () {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.validateAll();
      },
      submitCallback () {
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>